module.exports = __webpack_public_path__ + "static/img/day4.1cc1a01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/day4.jpg
// module id = Cja+
// module chunks = 0